import React, {useEffect, useCallback, useState, createContext, useContext} from 'react';
import ClinicDropdown from '../../common/components/Clinics/ClinicDropdown';
import { useWatch } from 'react-hook-form';

const ClinicDropdownDialogContext = createContext();

export function ClinicDropdownDialogProvider({ children }) {
    const [dialogParams, setDialogParams] = useState({open: false, defaultName: '', timestamp: null});

    const openDialog = useCallback((name) => {
        setDialogParams(prevState => ({...prevState, open: true, timestamp: Date.now(), defaultName: name}));
    }, []);

    useEffect(() => {
        return () => {
            setDialogParams(prevState => ({...prevState, open: false, defaultName: ''}));
        };
    }, []);

    return (
        <ClinicDropdownDialogContext.Provider value={{ openDialog, ...dialogParams }}>
            {children}
        </ClinicDropdownDialogContext.Provider>
    );
}

export function useClinicDropdownDialog() {
    return useContext(ClinicDropdownDialogContext);
}

export default function ClinicDropdownHookFormSelect({control, errors, setValue, schema, onOptionsLoaded, label='Referring Clinic'}) {
    const value = useWatch({ control, name: schema });

    const error = errors && errors.hasOwnProperty(schema)
                    ? errors[schema]
                    : null;

    const { open: createClinicDialogVisible, defaultName, timestamp: createClinicDialogVisibleTimestamp } = useClinicDropdownDialog();

    const onChange = useCallback((e) => {
        setValue(schema, e.target.value);
    }, [setValue, schema]);

    return (
        <ClinicDropdown
            label={label}
            value={value}
            onChange={onChange}
            onOptionsLoaded={onOptionsLoaded}
            error={error}
            defaultName={defaultName}
            openDialogOverride={createClinicDialogVisible}
            openDialogOverrideTimestamp={createClinicDialogVisibleTimestamp}
        />
    );
}
